import { FC, useEffect, useState } from 'react'
import { IonButton, IonIcon, IonItem, IonLabel, IonList, IonListHeader, useIonToast } from '@ionic/react'
import { refresh } from 'ionicons/icons'
import { Accountant } from '../../../API'
import TbnAvatar from '../../../components/models/TbnAvatar'
import { AccountantService } from '../../../components/services/AccountantService'
import { TbnResponse } from '../../../components/services/TbnResponse'
import { failure } from '../../../components/util/Toast'

interface AccountantListProps {}
const AccountantList: FC<AccountantListProps> = () => {
  const [items, setItems] = useState<Accountant[]>([])
  const [presentToast] = useIonToast()

  const fetchItems = async () => {
    const res: TbnResponse = await AccountantService.Instance.list()
    if (res.data) setItems(res.data)
    else if (res.errorMessage) failure(res.errorMessage, presentToast)
  }

  useEffect(() => {
    fetchItems()
  }, []) // eslint-disable-line

  return (
    <IonList>
      <IonListHeader>
        <IonLabel>Accountants</IonLabel>
        <IonButton fill='clear' onClick={fetchItems}>
          <IonIcon icon={refresh} />
        </IonButton>
      </IonListHeader>
      {items.map((itm: Accountant) => (
        <IonItem key={itm.id}>
          <TbnAvatar avatar={itm.avatar} slot='start' />
          <IonLabel>{itm.name}</IonLabel>
        </IonItem>
      ))}
    </IonList>
  )
}

export default AccountantList
